<template>
  <BContainer
    class="px-0"
    fluid
  >

    <div class="py-2 w-100 border-bottom font-weight-bold text-muted mb-3">
      <div class="d-flex justify-content-between align-items-center">
        <div>FSO Memo Cascading this {{ monthLongFormatter(schedule) }}</div>
        <div>
          <BButton
            size="sm"
            variant="link"
            :to="{
              name: 'asm.tracking.customer-memos.pending'
            }"
          >
            <i class="far fa-circle-arrow-right fa-lg m-0 p-0" />
          </BButton>
        </div>
      </div>
    </div>

    <BRow
      v-if="busy"
      class="mb-3"
    >
      <BCol
        cols="12"
      >
        <div class="text-center py-5">
          <BIcon
            icon="stopwatch"
            font-scale="5"
            animation="cylon"
          />
          <p class="h6 py-2">
            <strong>Loading . . .</strong>
          </p>
        </div>
      </BCol>
    </BRow>

    <BRow
      v-else-if="customerMemos.rows.length === 0"
    >
      <BCol
        cols="12"
        class="text-center py-5"
      >
        <BIcon
          icon="calendar"
          font-scale="4"
        />
        <p class="h6 py-2">
          <strong>No FSO customer memos found</strong>
        </p>
      </BCol>
    </BRow>

    <BCardGroup
      v-else
      columns
    >
      <BCard
        v-for="customerMemo in customerMemos.rows"
        :key="customerMemo.sso_id"
      >
        <BCardText>
          <RouterLink
            :to="{
              name: 'asm.tracking.customer-memos.processing',
              params: {
                customerMemo: customerMemo.id
              }
            }"
          >
            <div class="d-flex gap-4 mb-2">
              <BAvatar
                v-if="customerMemo.photo_url"
                :src="computedProfilePath(customerMemo.photo_url)"
                variant="primary"
                size="50px"
              />
              <BAvatar
                v-else
                variant="primary"
                size="50px"
                :text="String(customerMemo?.first_name).charAt(0) + String(customerMemo?.last_name).charAt(0)"
              />
              <div class="d-flex flex-column justify-content-center">
                <div
                  class="font-weight-bolder"
                  style="font-size: 0.8rem;"
                >
                  {{ customerMemo?.first_name }} {{ customerMemo?.last_name }}
                </div>
                <div
                  class="mt-1 text-dark"
                  style="font-size: 0.7rem;"
                >
                  {{ Array.from(customerMemo?.clusters || []).map(cluster => cluster.cluster_name).join(', ') || '' }}
                </div>
              </div>
            </div>
          </RouterLink>
        </BCardText>

        <BCardText
          v-if="customerMemo.customer_memos_assigned.length === 0"
          class="text-muted"
        >
          No customer memos assigned
        </BCardText>

        <BCardText
          v-else
        >
          <CustomerMemo
            v-for="memo in customerMemo.customer_memos_assigned"
            :key="memo.id"
            :memo="{
              memo_name: memo?.memo?.memo_name || '',
              valid: memo.customer_memos_valid_count,
              invalid: memo.customer_memos_invalid_count
            }"
            :current-progress="{
              event: memo.customer_memos_closed_count
            }"
            :total-progress="{
              event: memo.customer_memos_assigned_count
            }"
            class="mt-2"
          />
        </BCardText>

      </BCard>
    </BCardGroup>
  </BContainer>
</template>
<script>
import CustomerMemo from '@/views/asm/dashboard/components/CustomerMemo.vue'
import { find } from 'lodash'

import MxFormatter from '@/mixins/formatter'

export default {
  name: 'ASMDashboardOfficers',

  components: {
    CustomerMemo
  },

  mixins: [
    MxFormatter
  ],

  props: {
    busy: {
      type: Boolean,
      default: () => false
    },
    schedule: {
      type: String,
      default: () => ''
    },
    customerMemos: {
      type: Object,
      default: () => ({
        totalRows: 0,
        rows: []
      })
    },
    businessAgreements: {
      type: Array,
      default: () => ([])
    }
  },

  methods: {
    computedProfilePath (photoUrl) {
      return `${process.env.VUE_APP_API_BASE_URL}/${photoUrl}`
    },

    getCustomerMemosById (asmId, key = '') {
      const customerMemo = find(this.customerMemos, { id: asmId })

      if (customerMemo) {
        if (Object.prototype.hasOwnProperty.call(customerMemo, key)) {
          return customerMemo[key]
        } else {
          return 0
        }
      }

      return 0
    },

    getBusinessAgreementsById (asmId, key = '') {
      const businessAgreement = find(this.businessAgreements, { id: asmId })

      if (businessAgreement) {
        if (Object.prototype.hasOwnProperty.call(businessAgreement, key)) {
          return businessAgreement[key]
        } else {
          return 0
        }
      }

      return 0
    }
  }
}
</script>
